import {Box, SelectChangeEvent, Typography} from '@mui/material';
import {Card, Grid, CardContent} from '@mui/material';
import {NoAppliedJobs, Filter} from '@jobseeker/feature-job/components';
import AppliedTile from './internalComponents/AppliedTile';
import AppliedTileV2 from './internalComponents/HiristAppliedTile';

import {AppliedMobProps} from '../AppliedJobsMobile/types';
import {
  AppDownloadBanner,
  FreeProBanner,
  InfiniteScroll,
  Loader,
} from '@jobseeker/lotus/components';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import {statusOptions as options} from '@jobseeker/feature-job/components/constants';
import {AppliedJobsInterface} from '@jobseeker/common-core/types/job/jobfeed.models';
import {findAppliedJobs} from '@jobseeker/common-core/reducers/job/thunkServices/jobfeed';
import NoJobsFound from '@jobseeker/feature-job/components/NoJobsFound';
import {useRouter} from 'next/router';
import {useMemo} from 'react';
import {Image} from '@jobseeker/lotus/components/Image';
import HiristBannerComponent from '@jobseeker/lotus/components/HiristBanner';
import {HiristTick} from '@jobseeker/lotus/assets/icons';
import {AppliedJobsQR, FreeProAppQR} from '@jobseeker/lotus/assets/images';
const AppliedJobsDes = ({
  setShowFollowUpProMembershipPrompt,
  setStatusProMembershipPrompt,
  setShowProMembershipPrompt,
  setInsightsOpen,
  userId,
  isStatusChangeCohortUser,
  calId,
  slotId,
  remSlots,
  concat,
  onInfiniteScroll,
  onLoadMore,
  setSelectedValues,
  selectedValues,
  isCohortEligible,
}: AppliedMobProps) => {
  const jobFeedStore = useSelector((state: AppState) => state.job);
  const clearFilter = async () => {
    setSelectedValues([]);
    await router.push(
      {pathname: router.pathname, query: {filters: ''}},
      undefined,
      {shallow: true}
    );
    router.reload();
  };
  const isQueryParamEmpty = (paramName: string) => {
    const queryParams = new URLSearchParams(router.asPath.split('?')[1]);
    const paramValue = queryParams.get(paramName);
    return paramValue === ''; // Returns true if the query parameter is empty
  };
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  const {
    profile: {subscriptions},
  } = useSelector((state: AppState) => state.user);
  const {isLoggedIn} = useSelector((state: AppState) => state.auth);
  const paramName = 'filters';
  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();
  const {isPro} = useSelector((state: AppState) => state.auth);
  const pro = !isAppIimjobs ? true : isPro;
  //  const followupAppStateremaining = useSelector((state: UserState) => state.profile?.followUpsRemaining);
  const followupremaining = useSelector(
    (state: AppState) => state.user.profile.followUpsRemaining
  );
  const router = useRouter();
  const {query} = router;

  let parsedFilters: number[] = [];
  if (query.filters) {
    parsedFilters = query.filters
      .toString()
      .split('_')
      .map(Number)
      .filter(num => !isNaN(num)); // Ensure valid numbers
  }
  if (isAppIimjobs && !isPro && isStatusChangeCohortUser === false) {
    parsedFilters = [];
  }

  const applyFilters = async () => {
    const filterString = selectedValues.join('_'); // Format as 1_2_3_4
    await router.push(
      {
        pathname: router.pathname,
        query: {filters: filterString},
      },
      undefined,
      {shallow: true}
    );

    router.reload();
  };
  const handleSelectChange = (event: SelectChangeEvent<number[]>) => {
    const selected = event.target.value as number[];
    if (selected.includes(1) && !selectedValues.includes(1)) {
      setSelectedValues(
        options.map(option => option.value).filter(value => value !== -1)
      );
    } else {
      if (!selected.includes(1) && selectedValues.includes(1)) {
        setSelectedValues([]);
      } else {
        let fs = selected;
        if (selected.includes(1) && selected.length < 8) {
          fs = selected.filter(f => f != 1);
        }
        setSelectedValues(fs);
      }
    }
  };

  const memoizedTiles = useMemo(
    () =>
      (jobFeedStore.jobfeed as AppliedJobsInterface[]).map((j, i: number) =>
        isAppIimjobs ? (
          <>
            <AppliedTile
              calId={calId}
              slotId={slotId}
              remSlots={remSlots}
              key={i}
              hasfollowup={followupremaining ? followupremaining : 0}
              setshowProMembershipPrompt={setShowProMembershipPrompt}
              setShowFollowUpProMembershipPrompt={
                setShowFollowUpProMembershipPrompt
              }
              setShowStatusProMembershipPrompt={setStatusProMembershipPrompt}
              setInsightsbox={setInsightsOpen}
              isPro={pro}
              isStatusChangeCohortUser={isStatusChangeCohortUser}
              {...j}
            />
            {i == 0 && isCohortEligible ? (
              <Box mx={2} mb={2}>
                <FreeProBanner QR={FreeProAppQR} />

                {/* <AppDownloadBanner
                  title="Know Your Recruiter Action Status, Instantly!"
                  subtitle="Download the iimjobs app to get instant notifications on every recruiter action, new job postings, saved jobs and more"
                  qrSize={70}
                  page={'AppliedJobs'}
                  QR={AppliedJobsQR}
                /> */}
              </Box>
            ) : (
              <></>
            )}
          </>
        ) : (
          <AppliedTileV2
            calId={calId}
            slotId={slotId}
            remSlots={remSlots}
            key={i}
            hasfollowup={followupremaining ? followupremaining : 0}
            setshowProMembershipPrompt={setShowProMembershipPrompt}
            setShowFollowUpProMembershipPrompt={
              setShowFollowUpProMembershipPrompt
            }
            setShowStatusProMembershipPrompt={setStatusProMembershipPrompt}
            setInsightsbox={setInsightsOpen}
            isPro={pro}
            isStatusChangeCohortUser={isStatusChangeCohortUser}
            {...j}
          />
        )
      ),
    [
      jobFeedStore.jobfeed,
      calId,
      slotId,
      remSlots,
      followupremaining,
      setShowProMembershipPrompt,
      setShowFollowUpProMembershipPrompt,
      setStatusProMembershipPrompt,
      setInsightsOpen,
      pro,
    ]
  );

  return (
    <>
      <Card
        sx={{
          boxShadow: isAppIimjobs ? 1 : 'none',
          borderRadius: isAppIimjobs ? 4 : 0,
          backgroundColor: isAppIimjobs ? '#fff' : 'transparent',
          width: '100%',

          boxSizing: 'border-box',
        }}
      >
        {isAppIimjobs ? (
          <></>
        ) : (
          <HiristBannerComponent
            showLinkage={true}
            isLoggedIn={isLoggedIn}
            subscriptions={subscriptions}
            userId={userId}
          >
            <>
              <Box width={88} mr={4} alignSelf="center">
                <Image
                  src={HiristTick}
                  alt="banner-icon"
                  width={70}
                  height={70}
                />
              </Box>
              <Box alignSelf="center">
                <Typography color="white" fontSize={16}>
                  Applied Jobs{' '}
                </Typography>
                <Typography
                  color="white"
                  fontSize={24}
                  maxWidth={733}
                  fontWeight={700}
                >
                  Check here all your applied jobs, Job status, follow-ups,
                  application status!!
                </Typography>
              </Box>
            </>{' '}
          </HiristBannerComponent>
        )}
        <Box
          sx={{
            width: isAppIimjobs
              ? 'auto'
              : {xxs: 'calc(100% - 32px)', md: 'calc(100% - 80px)'},
            ml: isAppIimjobs ? 0 : {xxs: 2, md: 6},
          }}
        >
          <Box display="flex" justifyContent="space-between">
            {/* Applied Jobs Title */}
            <Typography
              component={true ? 'p' : 'h1'}
              display="flex"
              fontWeight={isAppIimjobs ? '500' : '700'}
              paddingBottom={{xxs: 0}}
              height={30}
              mt={isAppIimjobs ? 4.125 : 2.5}
              marginLeft={isAppIimjobs ? 2 : 0}
              marginBottom={isAppIimjobs ? 2 : 2.5}
              sx={{
                cursor: 'default',
                fontSize: 20,
                wordWrap: 'break-word',
                textTransform: 'capitalize',
              }}
            >
              Applied Jobs
            </Typography>

            {/* Filter Component */}

            {pro || isStatusChangeCohortUser || !isAppIimjobs ? (
              <Filter
                options={options}
                handleSelectChange={handleSelectChange}
                selectedValues={selectedValues}
                applyFilters={applyFilters}
              />
            ) : (
              <></>
            )}
          </Box>

          {jobFeedStore.jobfeed.length ? (
            <>
              <Card
                elevation={0}
                sx={{
                  maxWidth: isAppIimjobs ? '95%' : '100%',
                  paddingBottom: 0,
                  marginBottom: 1.5,
                  borderRadius: isAppIimjobs ? 0 : 2,

                  marginleft: 4,
                  paddingleft: 6,
                }}
                data-testid="applied-jobs-card-title"
              >
                <CardContent
                  sx={{
                    backgroundColor: '',
                    paddingTop: isAppIimjobs ? 4 : 1,
                    paddingLeft: 3,
                    paddingBottom: isAppIimjobs ? -3 : '8px !important',
                    marginBottom: isAppIimjobs ? -2.5 : 0,
                    display: isAppIimjobs ? 'inline' : 'flex',
                    justifyContent: isAppIimjobs ? 'normal' : 'center',
                  }}
                >
                  <Grid
                    container
                    direction="row"
                    spacing="0"
                    sx={{
                      ml: isAppIimjobs ? 2.5 : 0,
                      mb: isAppIimjobs ? -2.5 : 0,
                      alignItems: isAppIimjobs ? 'normal' : 'center',
                    }}
                  >
                    {/* Date */}
                    <Grid
                      item
                      sx={{
                        height: {lg: 18, xxs: isAppIimjobs ? 36 : 18},
                      }}
                      xl={isAppIimjobs ? 1.48 : 4.7}
                      lg={isAppIimjobs ? 1.675 : 4.7}
                      xxs={isAppIimjobs ? 1.09 : 4.7}
                    >
                      <Typography
                        variant="body2"
                        color="textPrimary"
                        sx={{
                          fontSize: isAppIimjobs ? 12 : 14,
                          fontWeight: isAppIimjobs ? 600 : 700,
                          fontStyle: 'normal',
                          textAlign: isAppIimjobs
                            ? {
                                lg: 'left', // Left-align on large screens
                                xxs: 'center', // Center-align on medium screens and smaller
                              }
                            : 'left',
                          cursor: 'default',
                        }}
                      >
                        {' '}
                        {/* Match size and color */}
                        {isAppIimjobs ? 'APPLICATION DATE' : 'Title'}
                      </Typography>
                    </Grid>

                    {/* Title */}
                    <Grid
                      item
                      marginLeft={{xxs: isAppIimjobs ? 5 : 0, lg: 0}}
                      paddingLeft={0}
                      xl={isAppIimjobs ? 3.55 : 1.21}
                      lg={isAppIimjobs ? 3.35 : 1.21}
                      xxs={isAppIimjobs ? 3.9 : 1.21}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          height: isAppIimjobs ? 18 : 'auto',
                          fontSize: isAppIimjobs ? 12 : 14,
                          fontWeight: isAppIimjobs ? 600 : 700,
                          fontStyle: 'normal',
                          marginLeft: 0,
                          cursor: 'default',
                          width: isAppIimjobs ? '100%' : '80%',
                          ml: isAppIimjobs ? 0 : '10%',
                          textAlign: isAppIimjobs ? 'start' : 'center',
                          wordBreak: isAppIimjobs ? 'normal' : 'break-word', // Ensure long words break properly
                        }}
                      >
                        {isAppIimjobs ? 'TITLE' : 'Application Date'}
                      </Typography>
                    </Grid>

                    {/* Views */}
                    <Grid
                      item
                      marginLeft={0}
                      xl={isAppIimjobs ? 0.647 : 1.21}
                      lg={isAppIimjobs ? 0.65 : 1.21}
                      xxs={isAppIimjobs ? 0.665 : 1.21}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          height: 18,
                          cursor: 'default',
                          fontSize: isAppIimjobs ? 12 : 14,
                          fontWeight: isAppIimjobs ? 600 : 700,
                          fontStyle: 'normal',
                          textAlign: isAppIimjobs ? 'start' : 'center',
                        }}
                      >
                        {isAppIimjobs ? 'VIEWS' : 'Views'}
                      </Typography>
                    </Grid>

                    {/* Applications */}
                    <Grid
                      item
                      marginLeft={0}
                      xl={isAppIimjobs ? 1.1 : 1.21}
                      lg={isAppIimjobs ? 1.16 : 1.21}
                      xxs={isAppIimjobs ? 1.2 : 1.21}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          height: 18,
                          fontSize: isAppIimjobs ? 12 : 14,
                          fontWeight: isAppIimjobs ? 600 : 700,
                          fontStyle: 'normal',
                          cursor: 'default',
                          textAlign: isAppIimjobs ? 'start' : 'center',
                        }}
                      >
                        {isAppIimjobs ? 'APPLICATIONS' : 'Applications'}
                      </Typography>
                    </Grid>

                    {/* Recruiter Actions */}
                    <Grid
                      item
                      marginLeft={0}
                      xl={isAppIimjobs ? 2.0 : 1.21}
                      lg={isAppIimjobs ? 1.99 : 1.21}
                      xxs={1.21}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          height: isAppIimjobs ? {lg: 18, xxs: 36} : 'auto',
                          cursor: 'default',
                          fontSize: isAppIimjobs ? 12 : 14,
                          fontWeight: isAppIimjobs ? 600 : 700,
                          fontStyle: 'normal',
                          wordBreak: isAppIimjobs ? 'normal' : 'break-word', // Ensure long words break properly
                          width: isAppIimjobs ? '100%' : '78%',
                          ml: isAppIimjobs ? 0 : '11%',
                          textAlign: isAppIimjobs
                            ? {
                                lg: 'left', // Left-align on large screens
                                xxs: 'center', // Center-align on medium screens and smaller
                              }
                            : 'center',
                        }}
                      >
                        {isAppIimjobs
                          ? 'RECRUITER ACTIONS'
                          : 'Recruiter Actions'}
                      </Typography>
                    </Grid>

                    {/* Application Status */}
                    <Grid
                      item
                      marginLeft={0}
                      xl={isAppIimjobs ? 1.5 : 1.21}
                      lg={isAppIimjobs ? 1.5 : 1.21}
                      xxs={1.2}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          height: {lg: 18, xxs: isAppIimjobs ? 36 : 18},
                          fontSize: isAppIimjobs ? 12 : 14,
                          fontWeight: isAppIimjobs ? 600 : 700,
                          fontStyle: 'normal',
                          textAlign: isAppIimjobs
                            ? {
                                lg: 'left', // Left-align on large screens
                                xxs: 'center', // Center-align on medium screens and smaller
                              }
                            : 'center',
                          cursor: 'default',
                        }}
                      >
                        {isAppIimjobs ? 'APPLICATION STATUS' : 'Status'}
                      </Typography>
                    </Grid>

                    {/* Empty Space */}
                    <Grid
                      item
                      xs={isAppIimjobs ? 6 : 1.21}
                      xxs={isAppIimjobs ? 3 : 1.21}
                      xl={isAppIimjobs ? 1 : 1.21}
                    >
                      {isAppIimjobs ? (
                        <></>
                      ) : (
                        <Typography
                          variant="body2"
                          sx={{
                            height: {xxs: 18},
                            fontSize: isAppIimjobs ? 12 : 14,
                            fontWeight: isAppIimjobs ? 600 : 700,
                            fontStyle: 'normal',
                            textAlign: 'center',
                            cursor: 'default',
                          }}
                        >
                          Actions
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </>
          ) : (
            <></>
          )}

          {jobFeedStore.jobfeed.length ? (
            <InfiniteScroll
              dataLength={jobFeedStore?.jobfeed.length}
              next={onLoadMore}
              hasMore={!!jobFeedStore.loadMoreEnabled}
              onScroll={onInfiniteScroll}
              loader={
                <Box
                  sx={{
                    display: 'flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Loader />
                </Box>
              }
              style={{
                scrollbarWidth: 'none',
              }}
            >
              {/* {(jobFeedStore.jobfeed as AppliedJobsInterface[]).map((j, i) => (
              <AppliedTile
                calId={calId}
                slotId={slotId}
                remSlots={remSlots}
                key={i}
                hasfollowup={followupremaining ? followupremaining : 0}
                setshowProMembershipPrompt={setShowProMembershipPrompt}
                setShowFollowUpProMembershipPrompt={
                  setShowFollowUpProMembershipPrompt
                }
                setShowStatusProMembershipPrompt={setStatusProMembershipPrompt}
                setInsightsbox={setInsightsOpen}
                isPro={isPro}
                {...j}
              />
            ))} */}
              {memoizedTiles}
            </InfiniteScroll>
          ) : (parsedFilters &&
              parsedFilters.length > 0 &&
              parsedFilters?.length < 8) ||
            isQueryParamEmpty(paramName) ? (
            <NoJobsFound
              clearFilter={clearFilter}
              showBadge={true}
              source={'applied-jobs'}
            />
          ) : isAppIimjobs ? (
            <NoAppliedJobs />
          ) : (
            <NoJobsFound
              clearFilter={clearFilter}
              showBadge={true}
              source={'applied-jobs'}
            />
          )}
        </Box>
      </Card>
    </>
  );
};

export default AppliedJobsDes;
